import { render, staticRenderFns } from "./AuthLayer.vue?vue&type=template&id=2cf839c8&scoped=true"
import script from "./AuthLayer.vue?vue&type=script&lang=js"
export * from "./AuthLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf839c8",
  null
  
)

export default component.exports